module.exports = __webpack_public_path__ + "static/media/LetsGoo.2003c13d.png";